import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { HotlineCompleteLayout } from '@/feature/hotline/component/HotlineCompleteLayout';
import { HotlineOfferDescription } from '@/feature/hotline/component/HotlineOfferDescription';
import { hotlineProfessionalText } from '@/feature/hotline/professional/constant/text';
import { hotlineProFirstReplyCompleteViewStyle } from '@/feature/hotline/professional/firstReply/complete/page/style';
import { hotlineProFirstReplyBreadcrumbs } from '@/feature/hotline/professional/firstReply/constant/breadcrumbs';
import { pagePath } from '@/utils/router/pagePath';
/**
 * ホットライン 初回返信 完了画面（View 部分のみ）
 * @description View 全体の表示, api 取得データを表示用に変換して渡す
 */
export const HotlineProFirstReplyCompleteView = (props) => {
    const { id, title } = props;
    /** パンくず */
    const breadcrumbs = useMemo(() => hotlineProFirstReplyBreadcrumbs('complete', id, title), [id, title]);
    const style = hotlineProFirstReplyCompleteViewStyle();
    return (_jsx(HotlineCompleteLayout, Object.assign({ breadcrumbs: breadcrumbs, classNames: { childrenWrap: style.contentWrap() }, links: [
            { text: '相談一覧', to: pagePath.hotline.professional.list() },
            { text: 'マイページへ', to: pagePath.mypage.professional.index() },
        ], pageTitle: title, sectionLeadSentence: 'クライアントからの返信をお待ちください。', sectionTitle: '相談オファーを送信しました' }, { children: _jsx(HotlineOfferDescription, { items: hotlineProfessionalText.offerDescription(), title: 'クライアントから返信が届いたら' }) })));
};
